<ng-container *ngIf="expired$ | async">
  <section class="lock-session">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-7 bg-center"></div>
        <div class="col-xl-5 p-0 login-card">
          <!-- LOGIN -->
          <mat-card class="login-form">
            <mat-card-content>
              <img mat-card-image src="./assets/images/logo/sanetPN.svg" class="mb-4"/>
              <mat-card-title>{{labelFullName}}</mat-card-title>
              <mat-card-subtitle>{{ 'lbl_bloqueo' | translate : listTraduction.lbl }}</mat-card-subtitle>
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gy-3">
                <div *ngIf="showMessage">
                  <div mat-dialog-content class="message-card danger-card mb-0">
                    {{ message }}
                  </div>
                </div>
                <mat-label class="mt-3">{{ 'lbl_contraseña' | translate : listTraduction.lbl }}</mat-label>
                <input matInput [type]="!visibility ? 'password' : 'text'" class="form-control" formControlName="password" required placeholder="{{ 'ph_contraseña' | translate : listTraduction.ph }}" [errorStateMatcher]="matcher"/>
                <div class="float-end button-right-input">
                  <button mat-icon-button matSuffix (click)="visibility = !visibility" [attr.aria-pressed]="visibility" type="button">
                    <mat-icon>{{ !visibility ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </div>
                <mat-error *ngIf="!form.get('password')!.valid && form.get('password')!.touched">
                  <span class="msg-error d-block">{{ 'msg_contrasegna' | translate : listTraduction.msg }}</span>
                </mat-error>
                <button mat-flat-button type="submit" [disabled]="!form.valid" color="primary" class="w-100 mt-4">
                  {{ 'lbl_btn_desbloquear' | translate : listTraduction.lbl }}
                </button>
                <button mat-stroked-button type="button" color="primary" class="w-100 mt-3" (click)="newSession()">
                  {{ 'lbl_btn_nueva_sesion' | translate : listTraduction.lbl }}
                </button>
              </form>
            </mat-card-content>
          </mat-card>
					<app-version-label></app-version-label>
        </div>
      </div>
    </div>
  </section>
</ng-container>
